import Vue from 'vue'
import Router from 'vue-router'
import axios from 'axios'

import App from '@/App'

import routes from './routes'

Vue.use(Router)
const router = new Router({

  routes
})

// Before each route evaluates...
router.beforeEach((routeTo, routeFrom, next) => {
  // Check if auth is required on this route
  // (including nested routes).
  const authRequired = routeTo.matched.some(route => route.meta.authRequired)

  // If auth isn't required for the route, just continue.
  if (routeTo.name == 'Login' && localStorage.getItem('auth_token')) {

    return next({ name: 'Início' })
  }
  if (!authRequired) return next()
  // If auth is required and the user is logged in...
  if (localStorage.getItem('auth_token')) {
    axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('auth_token');
    // TODO: implementar isso aqui desse jeito
    // Validate the local user token...
    // return store.dispatch('auth/validate').then(validUser => {
      // Then continue if the token still represents a valid user,
      // otherwise redirect to login.
      // validUser ? next() : redirectToLogin()
    // })
    return next()
  }
  else {
    delete axios.defaults.headers.common['Authorization']
  }


  // If auth is required and the user is NOT currently logged in,
  // redirect to login.
  redirectToLogin()

  function redirectToLogin() {
    next({ name: 'Login' })
  }
})


export default router


// WEBPACK FOOTER //
// ./src/router/index.js